import { BillColumn, BillLineItemColumn } from "@common/types/views/billViews";

const ACCRUAL_ONLY_COLUMN_IDS = new Set<string>([
    BillColumn.STATUS,
    BillColumn.MATCH,
    BillLineItemColumn.STATUS,
    BillLineItemColumn.MATCH,
]);

export function hideAccrualOnlyColumns<TColumn extends { id: string }>({
    columns,
    hasAnyAccrualLedgers,
}: {
    columns: TColumn[];
    hasAnyAccrualLedgers: boolean;
}): TColumn[] {
    if (hasAnyAccrualLedgers) {
        return columns;
    }
    return columns.filter((column) => !ACCRUAL_ONLY_COLUMN_IDS.has(column.id));
}
